import script from "./weather.vue?vue&type=script&setup=true&lang=ts"
export * from "./weather.vue?vue&type=script&setup=true&lang=ts"

import "./weather.vue?vue&type=style&index=0&id=1d1aaba1&scoped=true&lang=less"

import exportComponent from "/Users/n0ts/Projects/IceCreamSearch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d1aaba1"]])

export default __exports__